import React,{useState,useEffect} from 'react';
import bookingService from "../../../../../../services/booking.service";
import { useEyeconxStore } from "../../../../../../store/eyeconxStore";
import Loading from "../../../../../common/Loading";

const AppointmentItem = ({item}) => {
    return (
        <>
            <li className="list-group-item">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex flex-column">
                        <span className="fw-bold">{item?.apptType}</span>
                         <span className="text-muted mt-1"><i className="bi bi-stopwatch me-2"></i>{item?.timeSlot} minutes</span>
                    </div>
                    {item?.isActive ? <span className="badge badge-primary text-bg-success text-white">Active</span>:<span className="badge badge-warning text-bg-warning text-white">Not Active</span>}
                </div>
            </li>
            </>
    )
}
const AppointmentTypeCard = ({onManage}) => {
    const clinicId = useEyeconxStore((state) => state.user.clinicId);
    const [appointmentTypes, setAppointmentTypes] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getAppointmentTypes();
    },[])

    const getAppointmentTypes = async () => {
        try{
            const res = await bookingService.getAllAppointmentTypes(clinicId);
            setAppointmentTypes(res.data);
            setIsLoading(false);
        } catch(error){
            console.log(error);
        }finally{
            setIsLoading(false);
        }
    }
    if(isLoading){
        return <Loading/>
    }
    return (
        <>


            <div className="card bg-light">
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                        <h4 className="card-title">
                            <i className="bi bi-calendar-event me-2"></i>
                            Appointment Types</h4>
                        <button className="btn btn-outline-primary" onClick={onManage}>Manage</button>
                    </div>


                    <div className="row">
                        <div className="col-12">
                            <ul className="list-group">
                                {appointmentTypes && appointmentTypes.length > 0 ? (
                                    appointmentTypes.map((apptType,index) => (
                                        <AppointmentItem key={index} item={apptType}/>
                                    ))
                                ):<>
                                    <div>
                                        No appointment types found.
                                    </div>
                                </>}

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            </>
    )
}

export default AppointmentTypeCard;